import getQueryParameter from './getQueryParameter';
/**
 * Throws an error wrapped in a timeout to trigger error reporting without breaking execution
 */
export default function bugAlert(msg: string | Error) {
  const audioDoc = Boolean(getQueryParameter('audioDoc'));
  const wordDoc = Boolean(getQueryParameter('word'));

  if (audioDoc || wordDoc) return;

  setTimeout(() => {
    if (msg instanceof Error) throw msg;
    else throw new Error(msg);
  });
}

// @ts-ignore
window.bugAlert = bugAlert;
